import { QuantifyReportDataPoint, SortBy } from '@modules/quantify/store/types';

export const isInvalidSortByField = (
  records: QuantifyReportDataPoint[],
  sortBy: SortBy,
  expectedSortBy?: SortBy,
) => {
  const isInvalidField = !records.some(
    (record) =>
      record.hasOwnProperty(sortBy.field) ||
      record.variants?.hasOwnProperty(sortBy.field),
  );

  if (!expectedSortBy) {
    return isInvalidField;
  }

  return (
    isInvalidField ||
    sortBy.field.toString() !== expectedSortBy.field.toString() ||
    sortBy.isAsc !== expectedSortBy.isAsc
  );
};
